import ApiService from '../../services/api.service';
import QuizresultModel from '../quizresult/quizresult-model';
import QuizquestionModel from '../quizquestion/quizquestion-model';
import EventquizModel from '../eventquiz/eventquiz-model';
import MedialibraryModel from '../medialibrary/medialibrary-model';

export default class QuizanswerModel {
    id: number;
    name: string;
    description: string;
    status: string;
    quizquestion: any;
    quizquestionCaption: string;
    title: string;
    content: string;
    image: any;
    imageId: number;
    imageUrl: string;
    seq: number;
    answer: string;
    value: number;
    quizresult: any;
    quizresultLength: number;
    quizresultCaption: string;
    eventquiz: any;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let quizquestion = datarow.quizquestion?.data? new QuizquestionModel(datarow.quizquestion?.data) : datarow.quizquestion;
        this.quizquestion = quizquestion?.id;
        this.quizquestionCaption = quizquestion?.name;
        this.title = datarow.title;
        this.content = datarow.content;
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        this.seq = datarow.seq;
        this.answer = datarow.answer;
        this.value = datarow.value;
        this.quizresult = datarow.quizresult?.data?.map((d: any) => new QuizresultModel(d));
        this.quizresultLength = this.quizresult?.length || 0;
        this.quizresultCaption = this.quizresultLength===0? '' : this.quizresult?.[0].name + (this.quizresultLength>1? ', ...' : '');
        this.eventquiz = datarow.eventquiz?.data?.map((d: any) => new EventquizModel(d));
    } 

    public static endPoint: string = 'quiz-answers';
    public static endPointMedia: string = 'api::quiz-answer.quiz-answer';
    public static endPointFilter: string = '?populate=*&sort=seq&filters[quizquestion]=';
    public static url: string = '/quizanswer';
    public static caption: string = 'Quiz Answer';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        quizquestion: null,
        quizquestionCaption: '',
        title: '',
        content: '',
        image: null,
        imageId: 0,
        imageUrl: '',
        seq: 0,
        answer: '',
        value: 0,
        quizresult: [],
        quizresultLength: 0,
        quizresultCaption: '',
        eventquiz: '',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'value', caption: 'Value' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'title', caption: '', type: 'caption' },
        { name: 'content', caption: '' },
        { name: 'imageUrl', caption: '', type:'media' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}